import { render, staticRenderFns } from "./MediaReferenceModal.vue?vue&type=template&id=6b06ebb3&"
import script from "./MediaReferenceModal.vue?vue&type=script&lang=js&"
export * from "./MediaReferenceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports